import React from 'react'
import './viewer.css'
import { url } from '../api.config'

class Viewer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            auther: '',
            date: '',
            article: ''
        }

        fetch(url + window.location.pathname)
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                this.setState({ title: result.title, auther: result.auther, date: result.date, article: result.article })
            });
    }

    render() {
        return (
            <div className='main'>
                <h1>{this.state.title}</h1>
                <p className='article-data'>{this.state.auther}&nbsp;{this.state.date}</p>
                <div className='page' dangerouslySetInnerHTML={{ __html: this.state.article }}>
                </div>
            </div>
        )
    }
}

export default Viewer
